import { createLogic } from 'redux-logic'
import { history } from '@app/store/history'
import handleErrors from '@app/helpers/handleErrors'
import { SYNC_TWR_DEVICE_STATES } from '@app/constants/scenes/twrDevices/twrDevices'
import { updateTwrDeviceStates } from '@app/actions/scenes/twrDevices/twrDevices'
import { deviceType } from '@app/lib/Scenes/devicesStatesConditions'
import { SELECT_CONDITION_STATE_TWR } from '@app/constants/routes'
import getDeviceStates from '@app/api/scenes/getDeviceStates'
import { API_REQUEST_CANCEL } from '@app/constants/apiRequest'
import { apiRequestSent, apiRequestDone, apiRequestFailed } from '@app/actions/apiRequest'

const fetchTwrDeviceStatesLogic = createLogic({
  type: SYNC_TWR_DEVICE_STATES,
  cancelType: API_REQUEST_CANCEL,

  process(_, dispatch, done) {
    const { secrets: { accessToken: { token } } } = store.getState()
    const { scenes: { currentSceneCreating: { currentCondition: { conditionDeviceId } } } } = store.getState()
    dispatch(apiRequestSent(SYNC_TWR_DEVICE_STATES))
    getDeviceStates(token, deviceType.twrDevices, conditionDeviceId)
      .then((response) => {
        const { data } = response
        dispatch(updateTwrDeviceStates(data))
        dispatch(apiRequestDone(SYNC_TWR_DEVICE_STATES))
        history.push(SELECT_CONDITION_STATE_TWR)
      })
      .catch((error) => {
        if (error) {
          const currentError = handleErrors(error)
          dispatch(apiRequestFailed(currentError))
        } else {
          throw new Error('getDeviceStates failed without error')
        }
      })
      .then(() => done())
  },
})

export default fetchTwrDeviceStatesLogic
